import api from "./api"

export default {
    async post(payload: { url: string, body: string, title: string, tags?: string[] }) {
        return api.request('/api/articles', 'POST', payload)
    },
    async put(payload: { url: string, body: string, _id: string, title: string, tags?: string[] }) {
        return api.request('/api/articles/' + payload._id, 'PUT', payload)
    },
    async all() {
        return api.request('/api/articles', 'GET')
    },
    async delete(_id: string) {
        return api.request('/api/articles/' + _id, 'DELETE')
    }
}
